module.exports = __webpack_public_path__ + "img/border_left_arrow.a83fd6e6.svg";